<div class="flex-align-center !flex justify-center">
    <h4 class="m-0 font-semibold dark:text-contrast-yellow" cdkFocusInitial>
        {{ 'MAP_VIEW_SETTING_TITLE' | translate }}
    </h4>
    <div class="absolute right-4 dark:filter-yellow">
        <button
            class="flex flex-row items-center justify-center text-grey-zambezy outline-none"
            [autofocus]="false"
            [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
            (click)="closeDialog()"
            mat-icon-button
            matDialogClose>
            <mat-icon class="text-2xl">close</mat-icon>
        </button>
    </div>
</div>

<div [ngClass]="{ 'high-contrast': isContrast$ | async }">
    <div *ngIf="data.layers.length > 1">
        <div class="border-ironside_grey-100 -mx-6 my-4 border-t border-solid dark:border-contrast-yellow"></div>
        <p class="text-base font-semibold text-grey-dark dark:text-contrast-yellow">
            {{ 'MAP_VIEW_SETTING_STYLE_TITLE' | uppercase | translate }}
        </p>
        <mat-button-toggle-group
            class="map-layer-toggle-group my-4 !flex flex-wrap"
            [formControl]="selectedLayer"
            [attr.aria-label]="'MAP_VIEW_SETTING_STYLE_TITLE' | translate">
            <mat-button-toggle class="flex-1 text-base" *ngFor="let option of data.layers" [value]="option">
                {{ option.label | translate }}
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <div class="border-ironside_grey-100 -mx-6 my-4 border-t border-solid dark:border-contrast-yellow"></div>

    <div class="my-2 text-base" *ngIf="filteredOverlays.length">
        <p class="font-semibold text-grey-dark dark:text-contrast-yellow">
            {{ 'MAP_VIEW_SETTING_LAYERS_TITLE' | uppercase | translate }}
        </p>
        <div class="mb-2" *ngFor="let option of filteredOverlays">
            <div class="border-ironside_grey-100 my-4 border-t border-solid dark:border-contrast-yellow"></div>
            <button
                class="map-toggle-button flex w-full cursor-pointer items-center justify-between text-left focus:outline-none"
                [attr.aria-checked]="isChecked(option.name)"
                [attr.aria-label]="option.label"
                (click)="onToggle(option.name)"
                type="button"
                role="switch">
                <span class="dark:text-contrast-yellow" aria-hidden="true">
                    {{ option.label }}
                </span>
                <mat-slide-toggle
                    class="pointer-events-none mr-2"
                    [checked]="isChecked(option.name)"
                    aria-hidden="true"
                    tabindex="-1">
                </mat-slide-toggle>
            </button>
        </div>
    </div>
</div>

<button
    class="confirm-btn var-app-light:text-primary orb-app-light-dark:font-semibold my-4 h-12 w-full overflow-hidden rounded-lg text-base font-bold dark:bg-contrast-yellow dark:text-contrast-black"
    [class]="saveButtonColor"
    (click)="onSubmit()">
    {{ 'SAVE_MAP_VIEW_SETTING_TITLE' | translate }}
</button>
